import { Api as apiService } from '../api';

export abstract class SamlEmailVerificationApi {
  static async checkIfUserHasSSO(email: string, csrf: string): Promise<{ redirectUrl?: string }> {
    return apiService.responseToJSONAndToastError(apiService.post(`/saml_email_verification`, { email, _csrf: csrf }));
  }
}
